
import ModuleBase, { subscribeMsg, implementFunction } from "../../../../framework/core/mvvm/module_base"

import * as ProtoPokerRoom from "../../net/proto/proto_poker_room";
import * as ProtoPokerLogin from "../../net/proto/proto_poker_login";
import NetMsgDataBase from "../../net/net_msg_data_table_base";
import TableBaseModel from "./table_base_model";
import TableBaseView from "./table_base_view";
import UserDataManager, { IUserCurrencyData } from "../../../../manager/user_manager";
import TablePlayerAvatar from "../../components/table_player_avatar";
import ModuleManager from "../../../../framework/core/module_manager";


const { ccclass } = cc._decorator;

enum ChatMsgType {
    voiceMsg = 0,
    shotMsg = 1,
    emojiMsg = 2,
    text = 3,
    gift = 10,
    tmpLeave = 99,
}

@ccclass
export default class TableBaseModule<V extends TableBaseView, M extends TableBaseModel> extends ModuleBase<V, M>  {


    onShow(intentData){
        super.onShow(intentData)
        //this.registerMsg()     
        this.registerNetMsg();   

        this.unregisstEventMsg()
        this.registEventMsg()
    }
    

    protected registerNetMsg(){

        this.model.subscibeMsgEvent<ProtoPokerLogin.Login.PingRsp>(NetMsgDataBase.Ping,this.onNetMsg_PingRsp.bind(this));

        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.ReadyRsp>(NetMsgDataBase.Ready,this.onNetMsg_ReadyRsp.bind(this));
        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.ReadyBroadcast>(NetMsgDataBase.ReadyNotify,this.onNetMsg_ReadyNotify.bind(this));
        
        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.EnterRsp>(NetMsgDataBase.EnterRoom,this.onNetMsg_EnterRsp.bind(this));
        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.EnterBroadcast>(NetMsgDataBase.EnterRoomNotify,this.onNetMsg_EnterNotify.bind(this));

        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.StartRsp>(NetMsgDataBase.Start,this.onNetMsg_StartRsp.bind(this));
        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.StartBroadcast>(NetMsgDataBase.StartNotify,this.onNetMsg_StartNotify.bind(this));

        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.LeaveRsp>(NetMsgDataBase.Leave,this.onNetMsg_LeaveRsp.bind(this));
        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.LeaveBroadcast>(NetMsgDataBase.LeaveNotify,this.onNetMsg_LeaveNotify.bind(this));

        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.ChatMsgRsp>(NetMsgDataBase.Chat,this.onNetMsg_ChatRsp.bind(this));
        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.ChatMsgBroadcast>(NetMsgDataBase.ChatNotify,this.onNetMsg_ChatNotify.bind(this));

        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.FreeRsp>(NetMsgDataBase.FreeRoom,this.onNetMsg_DissolveRsp.bind(this));
        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.FreeBroadcast>(NetMsgDataBase.FreeRoomRequestNotify,this.onNetMsg_DissolveNotify.bind(this));        
        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.FreeSuccessBroadcast>(NetMsgDataBase.FreeRoomNotify,this.onNetMsg_DissolveSuccessNotify.bind(this));

        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.DisconnBroadcast>(NetMsgDataBase.DisconnNotify,this.onNetMsg_DisconnectNotify.bind(this));
        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.ReconnBroadcast>(NetMsgDataBase.ReconnNotify,this.onNetMsg_ReconnectNotify.bind(this));
        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.ResetBroadcast>(NetMsgDataBase.ResetNotify,this.onNetMsg_ResetNotify.bind(this));

        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.CustomInfoChangeRsp>(NetMsgDataBase.CustomInfo,this.onNetMsg_CustomInfoChangeRsp.bind(this));
        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.CustomInfoChangeBroadcast>(NetMsgDataBase.CustomInfoNotify,this.onNetMsg_CustomInfoChangeNotify.bind(this));

        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.KickPlayerRsp>(NetMsgDataBase.KickPlayer,this.onNetMsg_KickPlayerRsp.bind(this));
        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.KickPlayerBroadcast>(NetMsgDataBase.KickPlayerBroadcast,this.onNetMsg_KickPlayerNotify.bind(this));
        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.OneShotSettleNotify>(NetMsgDataBase.OneShotSettleNotify,this.onNetMsg_OneShotSettleNotify.bind(this));

        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.IntrustRsp>(NetMsgDataBase.Intrust,this.onNetMsg_IntrustRsp.bind(this));
        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.IntrustNotify>(NetMsgDataBase.IntrustNotify,this.onNetMsg_IntrustNotify.bind(this));

        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.RechargeNotify>(NetMsgDataBase.RechargeNotify,this.onNetMsg_RechargeNotify.bind(this));

        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.UserCoinBalanceNotify>(NetMsgDataBase.UserCoinBalanceNotify,this.onNetMsg_UserCoinBalanceNotify.bind(this));
        this.model.subscibeMsgEvent<ProtoPokerRoom.Room.BatchCoinBalanceNotify>(NetMsgDataBase.BatchCoinBalanceNotify,this.onNetMsg_BatchCoinBalanceNotify.bind(this));
    }

    protected registEventMsg() {
        this.eventBind("player_coinbalance_changed", this.on_player_coinbalance_changed)
        this.eventBind('on_click_player_avatar', this.on_click_player_avatar)         
    }

    protected unregisstEventMsg() {
        
    }

    //@subscribeMsg(NetMsgDataBase.Ping)    
    protected onNetMsg_PingRsp(protoData: ProtoPokerLogin.Login.PingRsp) {
    }

    //@subscribeMsg(NetMsgDataBase.Ready)   
    protected onNetMsg_ReadyRsp(protoData: ProtoPokerRoom.Room.ReadyRsp) {
    }

    //@subscribeMsg(NetMsgDataBase.ReadyNotify)   
    protected onNetMsg_ReadyNotify(protoData: ProtoPokerRoom.Room.ReadyBroadcast) {
    }

    //@subscribeMsg(NetMsgDataBase.EnterRoom)   
    protected onNetMsg_EnterRsp(protoData: ProtoPokerRoom.Room.EnterRsp) {
    }

    //@subscribeMsg(NetMsgDataBase.EnterRoomNotify)   
    protected onNetMsg_EnterNotify(protoData: ProtoPokerRoom.Room.EnterBroadcast) {
    }

    //@subscribeMsg(NetMsgDataBase.Start)   
    protected onNetMsg_StartRsp(protoData: ProtoPokerRoom.Room.StartRsp) {
    }

    //@subscribeMsg(NetMsgDataBase.StartNotify)   
    protected onNetMsg_StartNotify(protoData: ProtoPokerRoom.Room.StartBroadcast) {
    }

    //@subscribeMsg(NetMsgDataBase.Leave)   
    protected onNetMsg_LeaveRsp(protoData: ProtoPokerRoom.Room.LeaveRsp) {
    }

    //@subscribeMsg(NetMsgDataBase.LeaveNotify)   
    protected onNetMsg_LeaveNotify(protoData: ProtoPokerRoom.Room.LeaveBroadcast) {
    }

    //@subscribeMsg(NetMsgDataBase.Chat)   
    protected onNetMsg_ChatRsp(protoData: ProtoPokerRoom.Room.ChatMsgRsp) {
    }

    //@subscribeMsg(NetMsgDataBase.ChatNotify)   
    protected onNetMsg_ChatNotify(protoData: ProtoPokerRoom.Room.ChatMsgBroadcast) {
    }

    //@subscribeMsg(NetMsgDataBase.FreeRoom)   
    protected onNetMsg_DissolveRsp(protoData: ProtoPokerRoom.Room.FreeRsp) {
    }

    //@subscribeMsg(NetMsgDataBase.FreeRoomRequestNotify)   
    protected onNetMsg_DissolveNotify(protoData: ProtoPokerRoom.Room.FreeBroadcast) {
    }

    //@subscribeMsg(NetMsgDataBase.FreeRoomNotify)   
    protected onNetMsg_DissolveSuccessNotify(protoData: ProtoPokerRoom.Room.FreeSuccessBroadcast) {
    }

    //@subscribeMsg(NetMsgDataBase.DisconnNotify)   
    protected onNetMsg_DisconnectNotify(protoData: ProtoPokerRoom.Room.DisconnBroadcast) {
    }

    //@subscribeMsg(NetMsgDataBase.ReconnNotify)   
    protected onNetMsg_ReconnectNotify(protoData: ProtoPokerRoom.Room.ReconnBroadcast) {
    }

    //@subscribeMsg(NetMsgDataBase.ResetNotify)   
    protected onNetMsg_ResetNotify(protoData: ProtoPokerRoom.Room.ResetBroadcast) {
    }

    //@subscribeMsg(NetMsgDataBase.CustomInfo)   
    protected onNetMsg_CustomInfoChangeRsp(protoData: ProtoPokerRoom.Room.CustomInfoChangeRsp) {
    }

    //@subscribeMsg(NetMsgDataBase.CustomInfoNotify)   
    protected onNetMsg_CustomInfoChangeNotify(protoData: ProtoPokerRoom.Room.CustomInfoChangeBroadcast) {
    }

    //@subscribeMsg(NetMsgDataBase.KickPlayer)   
    protected onNetMsg_KickPlayerRsp(protoData: ProtoPokerRoom.Room.KickPlayerRsp) {
    }

    //@subscribeMsg(NetMsgDataBase.KickPlayerBroadcast)   
    protected onNetMsg_KickPlayerNotify(protoData: ProtoPokerRoom.Room.KickPlayerBroadcast) {
    }

    //@subscribeMsg(NetMsgDataBase.OneShotSettleNotify)   
    protected onNetMsg_OneShotSettleNotify(protoData: ProtoPokerRoom.Room.OneShotSettleNotify) {
    }

    //@subscribeMsg(NetMsgDataBase.Intrust)   
    protected onNetMsg_IntrustRsp(protoData: ProtoPokerRoom.Room.IntrustRsp) {
    }

    //@subscribeMsg(NetMsgDataBase.IntrustNotify)   
    protected onNetMsg_IntrustNotify(protoData: ProtoPokerRoom.Room.IntrustNotify) {
    }

    //@subscribeMsg(NetMsgDataBase.RechargeNotify)   
    protected onNetMsg_RechargeNotify(protoData: ProtoPokerRoom.Room.RechargeNotify) {
    }

    //@subscribeMsg(NetMsgDataBase.UserCoinBalanceNotify)   
    protected onNetMsg_UserCoinBalanceNotify(protoData: ProtoPokerRoom.Room.UserCoinBalanceNotify) {
        this.onUserCoinBalanceNotify({playerId: protoData.playerId, coinBalance: protoData.coinBalance})
    }

    //@subscribeMsg(NetMsgDataBase.BatchCoinBalanceNotify)   
    protected onNetMsg_BatchCoinBalanceNotify(protoData: ProtoPokerRoom.Room.BatchCoinBalanceNotify) {
        for (let index = 0; index < protoData.players.length; index++) {
            const element = protoData.players[index];
            this.onUserCoinBalanceNotify({playerId: element.playerId, coinBalance: element.coinBalance})
        }        
    }

    protected onUserCoinBalanceNotify(data: {playerId: number, coinBalance: number}){
        data.playerId && UserDataManager.setUserGameTableCurrency(data.playerId, data.coinBalance)
    }

    protected on_player_coinbalance_changed(){
        this.model.send_user_coinbalance_request()
    }

    @implementFunction('onSelfCurrencyDataUpdate')
    protected onSelfDataUpdate(data: IUserCurrencyData){

    }

    protected onUserAvatarDataChangeNotify(data: {playerId: number}){
        this.eventDispatch('player_avatar_data_changed', data.playerId, true)
    }

    protected on_click_player_avatar(avatar: TablePlayerAvatar){
        let gold = null
        let chip = null

        chip = avatar.coinBalance
        ModuleManager.instance.showEmojiModule(avatar.uid, this.moduleName, gold, chip)
    }
}